import { trackEvent } from '../analytics'
import { HireMark } from '../components/Motifs'
import { EMAIL, HIRE } from '../data/content'

export default function Hire() {
  const mail = `mailto:${EMAIL}?subject=${encodeURIComponent(HIRE.mailSubject)}`

  return (
    <section className="sheet" id="hire">
      <div className="container">
        <div className="section-title">
          <HireMark className="section-mark" />
          <h2>{HIRE.heading}</h2>
        </div>
        <p className="lede">{HIRE.intro}</p>
        <div className="hire-layout">
          <div className="rule-cluster">
            <h3>{HIRE.takesHeading}</h3>
            <ul>
              {HIRE.takes.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
          <div className="rule-cluster rule-cluster-must">
            <h3>{HIRE.recordHeading}</h3>
            <ul>
              {HIRE.record.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
        <p className="price-line">
          <span>{HIRE.priceLine}</span>
          <a className="tlink" href={mail} onClick={() => trackEvent('email_click', { location: 'hire' })}>
            {HIRE.mailLabel}
          </a>
        </p>
      </div>
    </section>
  )
}
